// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"bd25b79b","106":"6e433fa7","254":"a3fa0865","453":"175433d1","487":"9f87290f","694":"21ee8f8c","706":"781cc6fe"}[chunkId] + ".chunk.js";
};